/**
 * Per-document settings stored via Office.context.document.settings.
 *
 * These values persist inside the .docx file and survive reopens of the same
 * document. They are scoped to *this* document only — open a different file and
 * the settings reset, which is the behaviour we want for "don't ask again for
 * this document".
 */

/* global Office */

const SKIP_TRACK_CHANGES_PROMPT = 'signus.skipTrackChangesPrompt';

function saveSettings(): Promise<void> {
  return new Promise((resolve, reject) => {
    Office.context.document.settings.saveAsync(result => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        resolve();
      } else {
        reject(new Error(result.error?.message ?? 'Failed to persist document settings.'));
      }
    });
  });
}

export function getSkipTrackChangesPrompt(): boolean {
  return Office.context.document.settings.get(SKIP_TRACK_CHANGES_PROMPT) === true;
}

export async function setSkipTrackChangesPrompt(skip: boolean): Promise<void> {
  Office.context.document.settings.set(SKIP_TRACK_CHANGES_PROMPT, skip);
  await saveSettings();
}
